import React from "react";
import groom from "assets/groom.png";
import { getString, LANG_EN, useLanguageStore } from "stores/language";
import CopyToClipboard from "react-copy-to-clipboard";
import CONSTANTS from "constants";
import toast from "react-hot-toast";

export default function Groom() {
  const language = useLanguageStore((state) => state.language);
  return (
    <div className="flex animate-fadeIn flex-col tablet:flex-row justify-center">
      <div className="bg-white p-4 rounded-2xl border border-black flex flex-col justify-between w-full tablet:w-[280px]">
        <div className="flex items-end text-sm">
          <img className="w-8 h-8 mr-1" src={groom} alt="" />
          <div>
            {getString(language, "groom")}
            <span className="font-bold text-lg">
              &nbsp;{getString(language, "groom_name")}
            </span>
          </div>
        </div>

        <div className="flex mt-2.5 text-sm" style={{ wordBreak: "keep-all" }}>
          {getString(language, "message")}
        </div>

        <div className="flex mt-2.5">
          <CopyToClipboard
            text={CONSTANTS.GROOM_BANK}
            onCopy={() =>
              toast.success(
                `${getString(language, "copied")}\n${CONSTANTS.GROOM_BANK}`
              )
            }
          >
            <a
              href="https://twitter.com/0xggoma"
              target="_blank"
              rel="noreferrer noopener"
              className="bg-[#2a9ceb] text-xs cursor-pointer text-white px-4 py-2 rounded-3xl mr-1"
            >
              {getString(language, "twitter")}
            </a>
          </CopyToClipboard>
          <CopyToClipboard
            text={CONSTANTS.GROOM_ETH}
            onCopy={() =>
              toast.success(
                `${getString(language, "copied")}\n${CONSTANTS.GROOM_ETH}`
              )
            }
          >
            <div className="bg-blue-500 text-white text-xs cursor-pointer px-4 py-2 rounded-3xl">
              {getString(language, "eth")}
            </div>
          </CopyToClipboard>
        </div>
      </div>
      <div className="bg-white p-4 rounded-2xl border border-black flex flex-col justify-between w-full tablet:w-[280px] mt-2 tablet:ml-2 tablet:mt-0">
        <div className="flex items-center text-sm">
          {getString(language, "groom_parents")}
        </div>

        <div className={`flex flex-col text-sm mt-2.5 `}>
          <div>
            <span className={`inline-block ${language === LANG_EN && "w-12"}`}>
              {getString(language, "dad")}
            </span>
            <span className="font-bold text-lg">
              &nbsp;{getString(language, "groom_dad")}
            </span>
          </div>
          <div>
            <span className={`inline-block ${language === LANG_EN && "w-12"}`}>
              {getString(language, "mom")}
            </span>
            <span className="font-bold text-lg">
              &nbsp;{getString(language, "groom_mom")}
            </span>
          </div>
        </div>

        <div className="flex mt-2.5">
          <CopyToClipboard
            text={CONSTANTS.GROOM_PARENTS_BANK}
            onCopy={() =>
              toast.success(
                `${getString(language, "copied")}\n${
                  CONSTANTS.GROOM_PARENTS_BANK
                }`
              )
            }
          >
            <div className="bg-[#463b3c] text-xs cursor-pointer text-white px-4 py-2 rounded-3xl">
              {getString(language, "bank")}
            </div>
          </CopyToClipboard>
        </div>
      </div>
    </div>
  );
}
